import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class AdminModel extends BaseModel {

    constructor() {
        super({ 
                name: "admin",
                tableName: 'users', 
                label: "Danh sách admin", 
                display_key: 'fullname', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                class: "center",
                width: 4,
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            fullname: {
                name: 'fullname', 
                type: "String",
                label: 'Tên hiển thị',
                class: "center",
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            email : {
                name: 'email', 
                type: "String", 
                label: 'Tài khoản', 
                sortable: false,
                class: "center",
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
            }
        },)
    }

}